// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"0b27905e","787":"26a9bb17","920":"9d226e8f"}[chunkId] + ".chunk.js";
};